<script setup lang="ts">
  import { RouterLink, useRoute } from 'vue-router'
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'

  const route = useRoute()
  const { t } = useI18n()
  const breadcrumbs = computed(() => {
    return route.matched.filter((item) => Boolean(item.meta?.title))
  })
</script>

<template>
  <div class="flex">
    <router-link v-for="(item, i) in breadcrumbs" :key="item.path" :to="item.path">
      <span
        class="flex font-medium text-sm leading-[130%]"
        :class="i === breadcrumbs.length - 1 ? 'text-shade-primary' : 'text-shade-secondary'"
      >
        <p class="text-nowrap">{{ t(item.meta.title as string) }}</p>
        <p v-if="i !== breadcrumbs.length - 1" class="mx-2 text-shade-tertiary">/</p>
      </span>
    </router-link>
  </div>
</template>
